module.exports = __webpack_public_path__ + "media/patterns/header-profile-2a634a94.png";